export function generateTitle(title) {
  return this.$t('route.' + title) // $t :this method from vue-i18n ,inject in @/lang/index.js
}

export function generateCustomizeString(str) {
  return this.$t('customize.' + str)
}

export function langShop(title) {
  return this.$t('shopRoute.' + title)
}
